import { html, ifDefined } from "../../../../"
import { SYSBaseElement } from "../../../sysbaseelement"
import { GetFieldLabel } from "../helpers"

import type { SYSField, SYSFormState } from "../../actions"
import {
  unsafeHTML,
  UnsafeHTMLDirective,
} from "lit-html/directives/unsafe-html.js"
import { DirectiveResult } from "lit-html/directive.js"

export class SYSControlLabel extends SYSBaseElement {
  field: SYSField
  props: any

  async init() {
    this.field = this.props()
    this.formState = <SYSFormState>(
      this.state.ovl.forms[this.field.formType][this.field.formId]
    )

    await super.init()
  }
  async getUI() {
    let formState = this.formState
    if (!formState) {
      return null
    }
    let field = formState.fields[this.field.fieldKey]
    if (field.ui.noLabel) {
      return null
    }
    let customHeaderCell
    if (formState._state._viewHeaderCell) {
      customHeaderCell = formState._state._viewHeaderCell[field.fieldKey]
    }
    let caption: DirectiveResult | string = ""
    if (field.ui.labelCaption) {
      caption = field.ui.labelCaption
    }
    let align = ""
    if (field.ui?.align) {
      align = `ovl-inputlabelalign-${field.ui.align}`
    }

    let customHeaderClassName = ""
    let customHeaderTooltip
    if (customHeaderCell) {
      customHeaderClassName = customHeaderCell.className
      customHeaderTooltip = customHeaderCell.tooltip
    }

    caption = GetFieldLabel(field, formState.feature, caption)

    if (typeof caption === "string") {
      caption = unsafeHTML(caption)
    }
    //let formState: FormState = state.ovl.forms[field.formType][field.formId]

    let allValidation = field.validationResult.System.concat(
      field.validationResult.Validate
    ).concat(field.validationResult.ValueChanged)

    let hint =
      field.watched &&
      allValidation.filter((f) => f.translationKey.indexOf("Mandatory") > -1)
        .length > 0
        ? "fd-form-label--required"
        : ""
    return html`
      <label
        title=${ifDefined(customHeaderTooltip)}
        class=${`fd-form-label ${align} ${hint}  ovl-formcontrol-label ovl-label__${field.fieldKey} ${customHeaderClassName}`}
        for=${field.id}
        >${caption}</label
      >
    `
  }
}
